<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Edit Text</cs-header-title>
</cs-header>

<cs-content>
  <input id="hidden-input" style="visibility: hidden; position: absolute;" type="file" accept="image/png, image/jpeg"
    (change)="onImageUploadEvent($event)" />

  <cs-card-list>
    <!-- Metadata Card -->
    <cs-card>
      <cs-card-title>Metadata</cs-card-title>
      <cs-card-content>
        <div class="form-content">
          <cs-form-field [label]="'Id' | untranslated" class="id-field">
            <cs-input type="text" [(value)]="text._id" [disabled]="!renameAllowed"></cs-input>
            <span class="field-hint">Unique identifier for the text. Used to identify the text in the database. Generated from title on first edit.</span>
          </cs-form-field>

          <cs-form-field [label]="'Title' | untranslated">
            <cs-input type="text" [(value)]="text.title" (valueChange)="nameChanged()"
              [placeholder]="'Type The Title Here First, then edit the generated id above!' | untranslated"></cs-input>
            <span class="field-hint">Title displayed on top of the help text.</span>
          </cs-form-field>
        </div>
      </cs-card-content>
    </cs-card>

    <!-- Text Content Card -->
    <cs-card>
      <cs-card-title>Content</cs-card-title>
      <cs-card-content>
        <cs-form-field [label]="'Text' | untranslated">
          <cs-textarea #descriptionTextarea [(value)]="text.text"></cs-textarea>
          <span class="field-hint">
            The body of the text shown to the user.
            Use <a href="https://www.markdownguide.org/extended-syntax/" target="_blank">Markdown</a> format for styling.
            To insert a video, insert an image with URL to a YouTube video.
          </span>
        </cs-form-field>
      </cs-card-content>
    </cs-card>

    <!-- Options Card -->
    <cs-card>
      <cs-card-title>Options</cs-card-title>
      <cs-card-content>
        <div class="settings-section">
          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-label">Preview</div>
              <div class="setting-description">Use this to check how the text will look to the users.</div>
            </div>
            <div class="setting-control">
              <cs-button secondary small (click)="previewHelpAsync()" [label]="'Preview' | untranslated" icon="eye"></cs-button>
            </div>
          </div>

          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-label">Add Image</div>
              <div class="setting-description">Image will be added at your current selection location.</div>
            </div>
            <div class="setting-control">
              <cs-button secondary small (click)="addImage()" [label]="'Add Image' | untranslated" icon="add"></cs-button>
            </div>
          </div>

          <div class="setting-row">
            <div class="setting-info">
              <div class="setting-label">Don't show in Help Page</div>
              <div class="setting-description">Whether text should be excluded from "Help & FAQ" page.</div>
            </div>
            <div class="setting-control">
              <cs-toggle [(checked)]="text.dontShowInHelpPage"></cs-toggle>
            </div>
          </div>
        </div>
      </cs-card-content>
    </cs-card>

  </cs-card-list>
</cs-content>

<cs-page-action-buttons>
  <cs-button secondary medium icon="trash" (click)="handleDeleteAndExit($event)" [label]="'Delete' | untranslated"></cs-button>
  <cs-button primary medium (click)="handleSaveAndExit($event)" [label]="'Save' | untranslated"></cs-button>
</cs-page-action-buttons>